/**
 * API helpers - use centralized axios (with error handling) via default import.
 * Ensure api/axiosSetup.js is imported before any API calls.
 */
import axios from "./axiosSetup";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "XSRF-TOKEN";

const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

// Use default axios (interceptors applied in axiosSetup.js)
const api = axios;

const url = (path) => {
  const normalizedPath = path.replace(/^\/+/, "");
  return `${baseUrl}/${normalizedPath}`;
};

// Fetch multiple objects
export const getObjects = async (endPoint, token = "") => {
  const config = token ? { headers: { Authorization: `Token ${token}` } } : {};
  const response = await api.get(url(`${endPoint}/`), config);
  return response.data;
};

// Fetch with query params (avoids malformed URLs like ?q=1/)
export const getObjectsWithParams = async (
  endPoint,
  params = {},
  token = ""
) => {
  const config = token
    ? { headers: { Authorization: `Token ${token}` }, params }
    : { params };
  const response = await api.get(url(`${endPoint}/`), config);
  return response.data;
};

// Fetch a single object by ID
export const getObject = async (endPoint, id, token = "") => {
  const config = token ? { headers: { Authorization: `Token ${token}` } } : {};
  const response = await api.get(url(`${endPoint}/${id}/`), config);
  return response.data;
};

// Add a new object
export const addObject = async (
  endPoint,
  objectData,
  token = "",
  isMultipart = false
) => {
  const config = {
    headers: {
      ...(token && { Authorization: `Token ${token}` }),
      ...(isMultipart ? {} : { "Content-Type": "application/json" }),
    },
  };

  const response = await api.post(url(`${endPoint}/`), objectData, config);
  return response.data;
};

// Update an existing object
export const updateObject = async (endPoint, objectData, id, token = "") => {
  const config = {
    headers: token ? { Authorization: `Token ${token}` } : {},
  };

  const response = await api.patch(
    `${baseUrl}/${endPoint}/${id}/`,
    objectData,
    config
  );
  return response.data;
};

// Delete an object
export const deleteObject = async (endPoint, id, token = "") => {
  const config = {
    headers: token ? { Authorization: `Token ${token}` } : {},
  };

  const response = await api.delete(url(`${endPoint}/${id}/`), config);
  return response.data;
};

// User login
export const loginUser = async (objectData) => {
  const response = await api.post(url("login/"), objectData);
  return response.data;
};

// Fetch user data
export const getUserData = async (token = "") => {
  const config = {
    headers: { Authorization: `Token ${token}` },
  };
  const response = await api.get(url("users/"), config);
  return response.data;
};
